import React from 'react';
import SectionTitle from '../../components/SectionTitle/SectionTitle';
import Navbar from '../../components/Navbar/Navbar';
import './Contactus.scss';
import ContactForm from '../../components/ContactForm/ContactForm';
import Footer from '../../sections/Footer/Footer';

const Contactus = () => {
    return (
        <>
            <section className='section-bg section-common contact-section'>
                <Navbar />
                <SectionTitle 
                    title="Contact TRUECARE"
                    description="Get in touch with us for your dental care needs. Visit our clinic in Yamunanagar or call us for appointments and inquiries."
                />
            </section>
            <section className='contact-form-area'>
                <ContactForm />
            </section>
            <Footer />
        </>
    );
};

export default Contactus;